/**
 * @generated SignedSource<<9a704bd5596795efc8bc44060c7a285d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainContent_Todo$data = {
  readonly body: string | null;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly publishedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly publishedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly title: string;
  readonly updatedBySessionId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoLinkedContent_todo">;
  readonly " $fragmentType": "WorkspaceTodoEditMainContent_Todo";
};
export type WorkspaceTodoEditMainContent_Todo$key = {
  readonly " $data"?: WorkspaceTodoEditMainContent_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainContent_Todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainContent_Todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "publishedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "publishedBy",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBySessionId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoLinkedContent_todo"
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "84edb854e5a15c21fa6891f435827361";

export default node;
